class DocumentationPathWall {

    enableHandlers(isWallCover) {

        $("div.action-button.is-path-wall.has-course").on("click.wallCourseButton", this._onClickWallCourseButton.bind(this));
        $("div.action-button.is-path-wall.has-assessment").on("click.wallAssessmentButton", this._onClickWallAssessmentButton.bind(this));
        $("div.action-button.is-path-wall.has-test").on("click.wallTestButton", this._onClickWallTestButton.bind(this));
        $("div.action-button.is-path-wall.has-game").on("click.wallGameButton", this._onClickWallGameButton.bind(this));
        $("div.bf-smart-list.path-wall-course-item > .locked-content").on("click.pathWallClass", this._onClickWallLockedClassButton.bind(this));
        $("div.bf-smart-list.path-wall-course-item .mark-favourite-advanced").on("click.onClickWallItemFavourite", this._onclickWallItemFavourite.bind(this));
        $("div.bf-smart-list.path-wall-course-item .openRatingButtonAdvanced").on("click.onClickWallItemRating", this._onclickWallItemRating.bind(this));
        $("div.scroll-action-button, #rateInputGroupPathScroll > span.ratingImg").on("click.onClickScrollActionButton", this._onClickScrollActionButton.bind(this));

        if (isWallCover) {
            $("div.bf-smart-list.path-wall-course-item .doc-details-access-button").on("click.pathWallClass", this._onClickWallClassButton.bind(this));
        } else {
            $("div.bf-smart-list.path-wall-course-item").on("click.pathWallClass", this._onClickWallClassButton.bind(this));
        }

    }

    setWallContainerManager() {

        function _resizeElements($container){
            $container.height($container.width() * 9/16);
        }

        const $audioContainer = $(".document-preview-advanced-container .advanced-view-audio-container");
        const $buttonContainer = $(".document-preview-advanced-container .advanced-button-doc-access-container");

        _resizeElements($audioContainer);
        _resizeElements($buttonContainer);

        $(window).off("resize.docContainers").on("resize.docContainers", function(){

            _resizeElements($audioContainer);
            _resizeElements($buttonContainer);

        });

    }

    setWallDescriptionAccordion() {

        function _applyAccordion(event) {

            const $this = $(this);

            if ($this.find(".description").height() > 60) {

                $this.addClass("collapsed");
                $this.find(".collapsible-icon").removeClass("d-none").addClass("collapsed");

            }

        }

        function _onClickDescription(event) {

            const $this = $(this);

            $this.toggleClass("collapsed");
            $this.find(".collapsible-icon").toggleClass("collapsed");

        }

        const $wallItemDescription = $("div.bf-smart-list.path-wall-course-item .panel-description");

        $wallItemDescription.each(_applyAccordion);
        $wallItemDescription.on("click.toggleDescription", _onClickDescription);

    }

    setWallPlayEventHandlers() {

        function _playMedia(event) {

            const $this = $(this);
            const $documentationPastil = $this.find('.documentation-pastil');
            const documentationMedia = $this.find($(this).attr('data-type'));

            if ($documentationPastil.length > 0) {

                $documentationPastil.remove();
                documentationMedia.attr('controls', true);

                setTimeout(function(){
                    documentationMedia[0].play();
                }, 100);

            }

        }

        if (!world.documentation_autoplay) {

            const $mediaContainer = $("div.bf-smart-list.path-wall-course-item .advanced-view-video-container, div.bf-smart-list.path-wall-course-item .advanced-view-audio-container");
            $mediaContainer.on("click.playMedia", _playMedia);

        }

    }

    setWallCarrouselEventHandlers() {
        const folder = documentationScreenController.getCurrentFolder();
        // En el nuevo layout el path puede abrirse sin carpeta actual: en ese caso se ajustan todos
        // los carruseles del muro del path.
        const folderSelector = folder ? "[data-folder='" + folder.id + "']" : "";
        const $carrousel = $("div.bf-smart-list.path-wall-course-item .owl-carousel-advanced" + folderSelector);

        _.forEach($carrousel, function (imgCarousel) {
            documentationScreenController.adjustImageCarousel($(imgCarousel));
        });

        documentationScreenController.carouselClick();
    }

    setWallPieChart() {

        const $pieChartContainer = $("div.bf-smart-list.path-wall-course-item .pie-chart-container");
        $pieChartContainer.each(DocumentationUtils.drawTestPieChart);

    }

    setWallBackgroundsIcons() {

        function _setBackgroundIcon(event) {

            const $this = $(this);
            const iconTitle = 'RATE_SMILE_' + $this.data('rating');

            $this.css('background-image', 'url(' + customIcons[iconTitle] + ')');

        }

        const $backgroundIcon = $("div.bf-smart-list.path-wall-course-item .background-icon");
        $backgroundIcon.each(_setBackgroundIcon);

    }

    setWallImageRatings() {

        function _setImageRating(event) {

            const $this = $(this);
            const iconTitle = 'RATE_SMILE_' + $this.data('rating');

            $this.attr('src', customIcons[iconTitle]);

        }

        const $imageRating = $("div.bf-smart-list.path-wall-course-item .image-doc-rating");
        $imageRating.each(_setImageRating);

    }

    setWallTintIcons() {

        function _tintIcon(event) {

            const $this = $(this);
            tintImage($this.attr('id'), $this.attr('data-icon'), $this.attr('data-color'));

        }

        const $iconCanvas = $("div.bf-smart-list.path-wall-course-item tintedCanvas");
        $iconCanvas.each(_tintIcon);

    }

    setWallInstagramHeaders() {
        function applyCollapsible(event) {

            const $this = $(this);
            const dataId = $this.data("id");
            const $selectedHeader = $("div.section-path-instagram[data-id=" + dataId + "]");

            $selectedHeader.toggleClass("collapsed");

        }

        const $collapsibleHeaders = $("div.section-path-instagram  div.collapsible-button");
        $collapsibleHeaders.on("click.collapsible", applyCollapsible);
    }

    setWallExpressHeaders() {

        function applyCollapsible(event) {

            const $this = $(this);
            const dataId = $this.data("id");
            const $selectedHeader = $("div.section-path-express[data-id=" + dataId + "]");

            $selectedHeader.toggleClass("collapsed");

        }

        const $collapsibleHeaders = $("div.section-path-express  div.collapsible-button");
        $collapsibleHeaders.on("click.collapsible", applyCollapsible);

    }

    _onClickWallAssessmentButton(event) {

        const documentationPath = documentationScreenController.documentationPath;

        documentationScreenController.reDrawFolder = false;
        documentationPath.onClickAssessmentButton(event);

    }

    _onClickWallCourseButton(event) {

        const $this = $(event.currentTarget);
        const documentationPath = documentationScreenController.documentationPath;
        const pathUtils = documentationPath.getPathUtils();

        if ($this.hasClass("is-not-started") || $this.hasClass("is-completed")) {

            documentationScreenController.reDrawFolder = false;

            const pathData = documentationPath.getPathData();
            const firstClass = pathUtils.getFirstClass(pathData);
            const firstClassId = firstClass.pathItemId;
            let $firstClass = null;

            if (pathData.coverName === "WALL") {
                $firstClass = $("div.bf-smart-list.path-wall-course-item[data-item-id=" + firstClassId + "] > .panel-header.doc-details-access-button");
            } else {
                $firstClass = $("div.bf-smart-list.path-wall-course-item[data-item-id=" + firstClassId + "]");
            }

            $firstClass.trigger("click");

        }

        if ($this.hasClass("is-in-process")) {

            const pathModes = documentationPath.getPathModes();
            const pathData = documentationPath.getPathData();
            const documentId = pathData.nextDocumentToComplete.id;
            const pathItemId = pathData.nextDocumentToComplete.pathItemId;
            const sectionId = pathData.sectionItemsDict[pathItemId] ? pathData.sectionItemsDict[pathItemId].id : null;
            let $smartListSection = null;
            let $smartListItem = null;

            if (sectionId) {
                $smartListSection = $("div.smart-list-section[data-id='" + sectionId + "']");
                $smartListSection.removeClass("collapsed");
            }

            if (pathData.mode === pathModes.WALL_MODE) {
                $smartListItem = $(".bf-smart-list.path-wall-course-item[data-document='" + documentId +  "']");
            } else {
                $smartListItem = $(".bf-smart-list.path-course-item[data-document='" + documentId +  "']");
            }

            window.scrollTo({
                top: $smartListItem.offset().top,
                left: 0,
                behavior: 'smooth'
            });

        }

    }

    _onClickWallTestButton(event) {

        const documentationPath = documentationScreenController.documentationPath;

        documentationScreenController.reDrawFolder = false;
        documentationPath.onClickTestButton(event);

    }

    _onClickWallGameButton(event) {

        const documentationPath = documentationScreenController.documentationPath;

        documentationScreenController.reDrawFolder = false;
        documentationPath.onClickGameButton(event);

    }

    _onClickWallClassButton(event) {

        event.preventDefault();
        documentationScreenController.reDrawFolder = false;

        const $this = $(event.currentTarget);
        const documentationProgress = documentationScreenController.documentationProgress;
        const documentationPath = documentationScreenController.documentationPath;
        const pathUtils = documentationPath.getPathUtils();
        const documentPathId = $this.data("item-id");
        let documentId = null;
        let document = null;
        let openDocumentDetailsOption = null;

        if ($this.attr('data-resource-id')) {
            documentId = parseInt($this.attr('data-resource-id'));
        }

        if ($this.attr('data-id')) {
            documentId = parseInt($this.attr('data-id'));
        }

        if ($this.attr('data-document')) {
            documentId = parseInt($this.attr('data-document'))
        }

        document = pathUtils.getSectionItem(documentId);
        documentationProgress.stopRead(documentId);

        if (['AUDIO', 'VIDEO'].indexOf(document.api_name_type) >= 0) {

            const $smartListItem = $('.bf-smart-list.path-wall-course-item[data-document=' + documentId + ']').find(document.api_name_type)[0];
            pauseMedia($smartListItem);

        }

        if ($this.data('comment')) {
            openDocumentDetailsOption = documentationScreenController.COMMENT_OPTION;
        }

        if ($this.data('sharing')) {
            openDocumentDetailsOption = documentationScreenController.SHARE_OPTION;
        }

        documentationPath.onClickClassButton(event, openDocumentDetailsOption);

    }

    _onClickWallLockedClassButton(event) {
        const documentationPath = documentationScreenController.documentationPath;
        documentationPath.openBlockedContentPopUp();
    }

    _onclickWallItemFavourite(event) {

        event.preventDefault();

        const $this = $(event.currentTarget);

        ga('send', 'event', analytics.GA_CATEGORY_DOCUMENTATION, analytics.GA_CATEGORY_DOCUMENTATION_EVENT_MAKE_FAVOURITE, $this.data("document"));

        docSocket.emit(SocketEvents.SET_FAVORITE_REQUEST(), JSON.stringify({
            document_id: $this.data("document")
        }));

    }

    _onclickWallItemRating(event) {

        function _onClickRateOption(event) {

            const $this = $(this);
            const points = $this.attr('data-rating');
            const $closestRateBar = $this.closest('.advanced-rate-input-bar');
            const documentId = $closestRateBar.data('document');

            $closestRateBar.siblings('.document-advanced-rating-background').hide();
            $closestRateBar.hide();

            documentationScreenController.elapsedSendingTime = null;

            ga('send', 'event', analytics.GA_CATEGORY_DOCUMENTATION, analytics.GA_CATEGORY_DOCUMENTATION_EVENT_RATE_DOCUMENT, documentId);
            docSocket.emit(SocketEvents.RATE_DOCUMENT_REQUEST(), JSON.stringify({
                rating: points,
                document_id: documentId
            }));

        }

        const $this = $(event.currentTarget);
        const $wallItem = $("div.bf-smart-list.path-wall-course-item");
        const docId = $this.data('document');
        const rateBar = $wallItem.find('#rate-input-' + docId);
        const rateArea = rateBar.siblings('div.document-advanced-rating-background');
        const $rateImages = $('div.advanced-rate-input-bar span');

        rateArea.toggle();
        rateBar.toggle();

        $this.toggleClass('world_color_1_bg');
        $rateImages.on('click.onClickRateOption', _onClickRateOption);

    }

    _onClickScrollActionButton(event) {

        const $this = $(event.currentTarget);
        const type = $this.data("action");
        const documentationPath = documentationScreenController.documentationPath;
        const pathData = documentationPath.getPathData();
        const documentId = pathData.document_root.id;

        if (type === "like") {

            const $markLikeButton = $(".mark-liked[data-document=" + documentId + "]");
            const $gifDocumentLiked = $("#gif-document-liked-" + documentId + "-scroll-path");

            // Prevenir error al pulsar varias veces seguidas y rapido sobre el boton de like.
            if ($gifDocumentLiked.children().length === 0) {
                $markLikeButton.trigger("click");
            }

        }

        if (type === "rate") {
            const points = $this.data("rating");
            ga('send', 'event', analytics.GA_CATEGORY_DOCUMENTATION, analytics.GA_CATEGORY_DOCUMENTATION_EVENT_RATE_DOCUMENT, documentId);
            docSocket.emit(SocketEvents.RATE_DOCUMENT_REQUEST(), JSON.stringify({rating: points, document_id: documentId}));
        }

    }

}